
import { Footer } from "../../../Footer"
import { ActionReport } from "../ActionReport/ActionReport"
import { IllegalReceivedComplaintsFromOfficials } from "../IllegalReceivedComplaintsFromOfficials/IllegalReceivedComplaintsFromOfficials"
import { IllegalSocialMediaAndOfficerVisit } from "../IllegalSocialMediaAndOfficerVisit/IllegalSocialMediaAndOfficerVisit"
import { SiteVerification } from "../SiteVerification/SiteVerification"
import { SiteVisit } from "../SiteVisit/SiteVisit"

export const IllegalConstructionDashboardComponents = () => {
    return (
        <>
            {/* Social Media And Officer Visit */}
            <IllegalSocialMediaAndOfficerVisit />

            <IllegalReceivedComplaintsFromOfficials />

            <SiteVisit />

            <SiteVerification />

            <ActionReport />

            <Footer />
        </>
    )
}